// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.single_article_first_container {
  display: flex !important;
  justify-content: center !important;
  position: relative;
}
.single_article_top_details_wrapper {
  z-index: 2;
  position: relative;
  margin-top: 2%;
}
.single_article_title_report_share_save_container {
  width: 100%;
}
.single_article_back_ground_container {
  position: absolute;
  background-color: #140f2d;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 60%;
  z-index: 1;
}
.single_article_first_column_title {
  font-family: kufam;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.single_article_top_icons {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.single_article_top_icons_container {
  width: 100%;
  justify-content: flex-end !important;
  display: flex;
  gap: 3%;
  padding-bottom: 4%;
}
.single_article_writer_details_container {
  height: 50%;
  display: flex;
  gap: 3%;
}
.writer_profile_image {
  width: 80px;
  height: 80px;
  cursor: pointer;
  border-radius: 50%;
  object-fit: cover !important;
}
.single_article_writer_details_wrapper {
  display: flex;
  flex-direction: column;
  width: 80% !important;
  justify-content: space-between;
}
.writer_name {
  color: var(--subtitle-color);
  font-weight: 600;
}
.published_date {
  color: var(--subtitle-color);
}
.single_article_reading_time {
  color: var(--subtitle-color);
}
.single_article_view_count {
  color: var(--view-icon-color);
}
.single_article_view_and_reading_time {
  display: flex;
  gap: 7%;
}
.single_article_icons {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
}
.report_share_container_mobile_view {
  border-top: 1px solid #f49d36;
  border-bottom: 1px solid #f49d36;
  display: flex;
  justify-content: space-between;
  padding: 3% 0 3% 0;
}
.report_share_first_column_container {
  display: flex;
  gap: 8%;
  width: 50%;
}
.report_share_second_column_container {
  display: flex;
  width: 20%;
  justify-content: space-between;
}
.single_article_details_with_donation_container {
  width: 90%;
  display: flex;
  justify-content: space-between;
}
.join_whatsapp_channel {
  background-color: #00704a;
  border-radius: 10px;
  padding: 1%;
  display: flex;
  padding: 2%;
  align-items: center;
  cursor: pointer;
  margin-bottom: 10px;
}
.whatsapp_gif_icon {
  width: 100%;
}
.social_media_card_container {
  border-radius: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: var(--gradient-color);
}
.social_media_image_container {
  width: 50%;
  display: flex;
  gap: 10%;
  align-items: center;
}
.single_article_social_media_name {
  color: #ffffff;
  cursor: pointer;
}
.stay_connected_text {
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
}
.single_article_social_media_icon {
  width: 15%;
  cursor: pointer;
}
.social_media_card_wrapper {
  position: sticky !important;
  top: 110px;
  min-height: 300px;
}
.single_article_details_with_donation_wrapper {
  display: flex;
  width: 100%;
  justify-content: center;
  padding: 4% 0 0 0;
  margin-bottom: 40px;
}
.report_container {
  border: 1px solid black;
  width: 100%;
  border-radius: 20px;
  display: flex;
  gap: 5%;
  padding: 5% 5% 5% 5%;
  flex-direction: column;
  justify-content: space-between;
}
body.dark_mode .report_container {
  border: 1px solid white;
}
.report_container_first_column {
  width: 40%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.report_container_second_column {
  width: 70%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 5%;
}
.single_article_report_button {
  width: 100%;
  background-color: #e84756;
  color: #ffffff;
  border: none;
}
.single_article_report_button:hover {
  background-color: #e84756 !important;
  color: #ffffff !important;
}
.report_title {
  font-weight: 700;
  font-size: 25px;
}
.mick_image {
  width: 45%;
}
.mick_image_container {
  display: flex;
  justify-content: flex-end;
}

.share_save_container {
  display: flex;
  border-top: 1px solid #f49d36;
  border-bottom: 1px solid #f49d36;
  width: 100%;
  justify-content: space-between;
  padding: 2% 0 2% 0;
}
.share_save_container_second_column {
  display: flex;
  justify-content: flex-end;
  width: 80%;
  gap: 5%;
}

.save_share_text {
  columns: var(--subtitle-color);
  cursor: pointer;
}
.save_share_icon {
  width: 20px;
  cursor: pointer;
}
.single_article_icons_wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 20%;
}
.article_share_icon {
  height: 25px;
}
.article_share_icons {
  height: 20px;
}
.share_container {
  display: flex;
  gap: 10px;
}
.aligncenter {
  width: 100% !important;
  object-fit: contain !important;
  height: auto !important;
}
.single_article_content_container {
  display: flex;
  flex-direction: column;
}
.whatsapp_channel_content {
  color: #ffffff;
  width: 100%;
}
.copy_to_clipboard_icon {
  height: 25px;
  cursor: pointer;
}
.single_fact_check_mick_image_container {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.single_fact_check_mick_image {
  width: 100%;
}
.writer_details {
  width: 100%;
  margin: 10%;
}
.single_article_first_column_title_ta {
  font-family: kufam;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.article-content {
  text-align: justify !important;
}
.article-content img{
  width: 100% !important;
  height: auto !important;
    }
    
    .video-content {
      width: 100%;
      height: auto;
  }
    
   
.white_text {
  color: white !important;
}
.save_icon_wrapper {
  display: flex;
  justify-content: center;
  flex-direction: row;
  gap: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout/single_article.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,oCAAoC;EACpC,aAAa;EACb,OAAO;EACP,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,OAAO;AACT;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,OAAO;AACT;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,OAAO;EACP,UAAU;AACZ;AACA;EACE,aAAa;EACb,UAAU;EACV,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,iCAAiC;AACnC;AACA;EACE,UAAU;EACV,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,OAAO;EACP,oBAAoB;EACpB,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,OAAO;AACT;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,gCAAgC;EAChC,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,UAAU;EACV,OAAO;AACT;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,uBAAuB;IACrB;;IAEA;MACE,WAAW;MACX,YAAY;EAChB;;;AAGF;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV","sourcesContent":[".single_article_first_container {\n  display: flex !important;\n  justify-content: center !important;\n  position: relative;\n}\n.single_article_top_details_wrapper {\n  z-index: 2;\n  position: relative;\n  margin-top: 2%;\n}\n.single_article_title_report_share_save_container {\n  width: 100%;\n}\n.single_article_back_ground_container {\n  position: absolute;\n  background-color: #140f2d;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  height: 60%;\n  z-index: 1;\n}\n.single_article_first_column_title {\n  font-family: kufam;\n  font-weight: 700;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.single_article_top_icons {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n.single_article_top_icons_container {\n  width: 100%;\n  justify-content: flex-end !important;\n  display: flex;\n  gap: 3%;\n  padding-bottom: 4%;\n}\n.single_article_writer_details_container {\n  height: 50%;\n  display: flex;\n  gap: 3%;\n}\n.writer_profile_image {\n  width: 80px;\n  height: 80px;\n  cursor: pointer;\n  border-radius: 50%;\n  object-fit: cover !important;\n}\n.single_article_writer_details_wrapper {\n  display: flex;\n  flex-direction: column;\n  width: 80% !important;\n  justify-content: space-between;\n}\n.writer_name {\n  color: var(--subtitle-color);\n  font-weight: 600;\n}\n.published_date {\n  color: var(--subtitle-color);\n}\n.single_article_reading_time {\n  color: var(--subtitle-color);\n}\n.single_article_view_count {\n  color: var(--view-icon-color);\n}\n.single_article_view_and_reading_time {\n  display: flex;\n  gap: 7%;\n}\n.single_article_icons {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n}\n.report_share_container_mobile_view {\n  border-top: 1px solid #f49d36;\n  border-bottom: 1px solid #f49d36;\n  display: flex;\n  justify-content: space-between;\n  padding: 3% 0 3% 0;\n}\n.report_share_first_column_container {\n  display: flex;\n  gap: 8%;\n  width: 50%;\n}\n.report_share_second_column_container {\n  display: flex;\n  width: 20%;\n  justify-content: space-between;\n}\n.single_article_details_with_donation_container {\n  width: 90%;\n  display: flex;\n  justify-content: space-between;\n}\n.join_whatsapp_channel {\n  background-color: #00704a;\n  border-radius: 10px;\n  padding: 1%;\n  display: flex;\n  padding: 2%;\n  align-items: center;\n  cursor: pointer;\n  margin-bottom: 10px;\n}\n.whatsapp_gif_icon {\n  width: 100%;\n}\n.social_media_card_container {\n  border-radius: 10px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background: var(--gradient-color);\n}\n.social_media_image_container {\n  width: 50%;\n  display: flex;\n  gap: 10%;\n  align-items: center;\n}\n.single_article_social_media_name {\n  color: #ffffff;\n  cursor: pointer;\n}\n.stay_connected_text {\n  color: #ffffff;\n  font-size: 20px;\n  font-weight: 700;\n}\n.single_article_social_media_icon {\n  width: 15%;\n  cursor: pointer;\n}\n.social_media_card_wrapper {\n  position: sticky !important;\n  top: 110px;\n  min-height: 300px;\n}\n.single_article_details_with_donation_wrapper {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  padding: 4% 0 0 0;\n  margin-bottom: 40px;\n}\n.report_container {\n  border: 1px solid black;\n  width: 100%;\n  border-radius: 20px;\n  display: flex;\n  gap: 5%;\n  padding: 5% 5% 5% 5%;\n  flex-direction: column;\n  justify-content: space-between;\n}\nbody.dark_mode .report_container {\n  border: 1px solid white;\n}\n.report_container_first_column {\n  width: 40%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.report_container_second_column {\n  width: 70%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  gap: 5%;\n}\n.single_article_report_button {\n  width: 100%;\n  background-color: #e84756;\n  color: #ffffff;\n  border: none;\n}\n.single_article_report_button:hover {\n  background-color: #e84756 !important;\n  color: #ffffff !important;\n}\n.report_title {\n  font-weight: 700;\n  font-size: 25px;\n}\n.mick_image {\n  width: 45%;\n}\n.mick_image_container {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.share_save_container {\n  display: flex;\n  border-top: 1px solid #f49d36;\n  border-bottom: 1px solid #f49d36;\n  width: 100%;\n  justify-content: space-between;\n  padding: 2% 0 2% 0;\n}\n.share_save_container_second_column {\n  display: flex;\n  justify-content: flex-end;\n  width: 80%;\n  gap: 5%;\n}\n\n.save_share_text {\n  columns: var(--subtitle-color);\n  cursor: pointer;\n}\n.save_share_icon {\n  width: 20px;\n  cursor: pointer;\n}\n.single_article_icons_wrapper {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 20%;\n}\n.article_share_icon {\n  height: 25px;\n}\n.article_share_icons {\n  height: 20px;\n}\n.share_container {\n  display: flex;\n  gap: 10px;\n}\n.aligncenter {\n  width: 100% !important;\n  object-fit: contain !important;\n  height: auto !important;\n}\n.single_article_content_container {\n  display: flex;\n  flex-direction: column;\n}\n.whatsapp_channel_content {\n  color: #ffffff;\n  width: 100%;\n}\n.copy_to_clipboard_icon {\n  height: 25px;\n  cursor: pointer;\n}\n.single_fact_check_mick_image_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n.single_fact_check_mick_image {\n  width: 100%;\n}\n.writer_details {\n  width: 100%;\n  margin: 10%;\n}\n.single_article_first_column_title_ta {\n  font-family: kufam;\n  font-weight: 700;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.article-content {\n  text-align: justify !important;\n}\n.article-content img{\n  width: 100% !important;\n  height: auto !important;\n    }\n    \n    .video-content {\n      width: 100%;\n      height: auto;\n  }\n    \n   \n.white_text {\n  color: white !important;\n}\n.save_icon_wrapper {\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  gap: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
